import React from 'react'
import styled from 'styled-components'
import { SCHOOL } from '@laputan/core'
import { Dropdown } from './index'

const StyledSchoolStateDropdown = styled(Dropdown)`
  margin-right: 0;
`

interface ISchoolStateDropdownProps {
  className?: string
  value?: string
  onChange?: (value: string) => void
  isMenuLeft?: boolean
  validationMessage?: string
  required?: boolean
  name?: string
  labelText?: string
}

const SchoolStateDropdown: React.FC<ISchoolStateDropdownProps> = ({
  className,
  validationMessage,
  value,
  required = false,
  onChange,
  isMenuLeft = true,
}) => (
  <StyledSchoolStateDropdown
    labelText="State"
    validationMessage={validationMessage}
    className={className}
    required={required}
    isShowDefault
    isMenuLeft={isMenuLeft}
    onChange={(s) => {
      if (s === value) {
        return
      }
      onChange(s)
    }}
    items={[{ value: null, text: 'All States' }].concat(SCHOOL.STATES_SEQUENCE)}
    value={value}
  />
)

export { SchoolStateDropdown }
